import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, doc, ornament, text } from "./kit";
import type { LabelTemplate } from "./types";

// Rustic / natural: a bunch of grapes off-centre and relaxed, left-set type.
function wine(): CanvasData {
  const left = { x: 9, width: 72, align: "left" as const };
  return doc("wine", INK["warm-white"], [
    ornament("grape-bunch", INK.bronze, { width: 30, at: [9, 8], anchor: [8.5, 2] }),
    text({ ...left, text: "your name", font: "playfair", italic: true, size: 6, color: INK.bronze, baseline: 66 }),
    text({ ...left, text: "a small batch, shared with friends", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 73.5, tracking: 0.04 }),
    text({ ...left, text: "2026", font: "playfair", size: 3, color: INK.forest, baseline: 86, tracking: 0.06 }),
  ]);
}

export const rusticNatural: LabelTemplate = {
  key: "rustic-natural",
  name: "Rustic",
  occasion: "celebration",
  style: "Rustic · natural",
  description: "A bunch of grapes and relaxed, left-set type.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
